import {useMemo} from "react";

export type Size = "2xs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";

// TODO: this is definitely a `tva` function
export function useChannelLogoVariant(size: Size) {
    return useMemo(() => {
        const channelLogoVariants = {
            "2xs": {
                logoSizeClassName: "h-2 w-2",
                textSize: "xs",
                space: "xs"
            },
            xs: {
                logoSizeClassName: "h-3 w-3",
                textSize: "xs",
                space: "xs"
            },
            sm: {
                logoSizeClassName: "h-4 w-4",
                textSize: "sm",
                space: "xs"
            },
            md: {
                logoSizeClassName: "h-5 w-5",
                textSize: "md",
                space: "xs"
            },
            lg: {
                logoSizeClassName: "h-6 w-6",
                textSize: "lg",
                space: "xs"
            },
            xl: {
                logoSizeClassName: "h-8 w-8",
                textSize: "lg",
                space: "xs"
            },
            "2xl": {
                logoSizeClassName: "h-9 w-9",
                textSize: "lg",
                space: "xs"
            },
            "3xl": {
                logoSizeClassName: "h-12 w-12",
                textSize: "lg",
                space: "xs"
            }
        } satisfies Record<
            Size,
            {
                logoSizeClassName: string;
                textSize: "xs" | "sm" | "md" | "lg";
                space: "xs";
            }
        >;
        return channelLogoVariants[size];
    }, [size]);
}
